import { View, useBreakpointValue } from "@gluestack-ui/themed";
import { PageContainerProps } from "./types";

export const PageContainer = (props: PageContainerProps) => {
  const { children } = props;

  const padding = useBreakpointValue({
    base: "$2",
    md: "$4",
    lg: "$6",
  });

  return (
    <View w="$full" maxWidth={"$container"} px={padding} m="auto">
      {children}
    </View>
  );
};
